<template>
    <li>
        <div class="title"><span>対象店舗</span></div>
        <div class="detail ">

            <div class="edit-select" v-if="!showShowroom">
                <select name="edit-particular-net" id="" v-model="net_shop" v-bind:class="{ '_error _required':  $store.state.register.errors.net_shop }">
                    <option v-for="net_shop in net_shops"
                        v-bind:value="net_shop.id "
                        v-bind:key="net_shop.id">
                        {{ net_shop.name }}
                    </option>
                </select>
            </div>
            <span style="color: red" v-if="$store.state.register.errors.net_shop">必須項目を入力してください</span>

            <p v-if="showShowroom">
                <span>取り扱いブランドによる</span>
            </p>
        </div>
    </li>
</template>

<script>
    export default {
        data() {
            return {
                net_shop: '',
                net_shops: [
                    { id: 0, name: '実店舗・ECサイト両方可' },
                    { id: 1, name: '実店舗のみ可' },
                    { id: 2, name: 'ECサイトのみ可' },
                    { id: 3, name: 'POPUPのみ可'},
                    { id: 4, name: '卸無し'},
                ]
            }
        },
        created() {
            // 編集の場合
            if (this.$store.state.detail.set.brand.net_shop != null) {
                this.net_shop = this.$store.state.detail.set.brand.net_shop;
                this.$store.state.register.form.net_shop = this.$store.state.detail.set.brand.net_shop;
            }
            if (this.showShowroom) {
                this.net_shop = 3;
                this.$store.state.register.form.net_shop = 3;
            }
        },
        watch: {
            net_shop: function (value) {
                this.$store.state.register.form.net_shop = value;
            },
        },
        computed: {
            showShowroom() {
                var url = location.pathname;
                return url.indexOf( '/showroom' ) != -1;
            },
        }
    }
</script>
